export default __webpack_public_path__ + "static/media/ODFL.b0a955cf.png";